module.exports = __webpack_public_path__ + "static/media/conaching-engagement-no-data-bg.9504a682.svg";